import { css, html } from "../helpers/webComponents";

const styles: string = css`
    :host {
        height: 100%;
        width: 100%;
        display: flex;
        background-color: rgba(0, 0, 0, 0.8);
        justify-content: center;
    }
`;

export class ModalInventoryComponent extends HTMLElement {
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const element: HTMLElement = this.renderInventory();

        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(element);
    }

    private renderInventory(): HTMLElement {
        const element: HTMLElement = html`
            <div>
                <style>
                    ${styles}
                </style>

                <game-canvas></game-canvas>
                <game-inventory></game-inventory>
            </div>
        `;

        return element;
    }
}
